export const LOGIN = '/'
export const REGISTER = '/Register'
export const HOME = '/Home'
export const RECOVER_PASSWORD = '/RecoverPassword'
export const USER_PROFILE = '/UserProfile'
export const EMAIL_VERIFICATION = '/EmailVerification'
